import React from "react"

import { Checkmark } from "svgs"
import styles from "./success.module.scss"

const success = ({ success }) => {
  return (
    <div className={success ? styles.success : styles.hide}>
      <Checkmark />
      <div className={styles.text}>You're all set!</div>
    </div>
  )
}
export default success
